import { css } from '@emotion/react';

function getLinkStyles(_ref) {
  var theme = _ref.theme;
  return /*#__PURE__*/css("color:", theme.colors.primary, ";text-decoration:none;position:relative;background-image:linear-gradient(currentColor, currentColor);background-position:0% 100%;background-repeat:no-repeat;background-size:0% 0.1em;transition:background-size 150ms ease-in-out;:hover,:focus{background-size:100% 0.1em;}:focus{outline:none;}:visited{color:", theme.colors.secondary, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:getLinkStyles;"));
}

export { getLinkStyles };
